import LazySpinner from './LazySpinner';
export default LazySpinner;
